import Settings from '../component/settings';
import { getMyToken } from '../util/myTools';

export default ({ news }) => {
  return <Settings news={news} />;
};

export async function getServerSideProps(context) {
  const token = await getMyToken(context);

  return {
    props: {
      accessToken: token,
      omiEnv: process.env.OMI_ENV || '',
      nodeEnv: process.env.NODE_ENV || '',
    },
  };
}
